import {
    hxlessonInfo,
    mySourceExpInfo,
    myLeveInfo
} from '../../../api/wz/serverApi'

import {assign, getServerTime, dataFormat } from '../../../utils/base'
import { update } from '../../../utils/vuex'

const state = {
    myExp       : 0,
    isHexun     : null,
    isSina      : null,
    powerInfo   : null,
    thisLevel   : null,
    nextLevel   : null,
}
export default {
    namespaced: true,
    state,    
    getters: {
        
    },
    actions: {
        async hxInfo({commit}, query){
            const R = await hxlessonInfo(query)
            let isHexun = R.data?true:false
            
            commit('update', {
                isHexun
            })    
            return R 
        },
        async sourceExp ({commit}, query){
            const R = await mySourceExpInfo(query)              
            return R 
        },
        async getLeveInfo ({commit}, query){
            const R = await myLeveInfo(query)
            let powerInfo = R.powerInfo || null
            let thisLevel = R.thisLevel || null
            let nextLevel = R.nextLevel || null
            let myExp = powerInfo.exp ? powerInfo.exp : 0
            commit('update', {
                powerInfo,
                thisLevel,
                nextLevel,
                myExp
            })

            return R 
        }
    },
    mutations: {
        update,
    }
}